// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './stores'
import App from './App'
import router from './router'
import * as filters from './filters'
import '@/styles/index.styl'
import '@/static/theme/index.css'
import '@/permission' // permission control
import Flex from '@/components/Common/Flex.vue'
import BackTop from '@/components/Common/BackTop.vue'
import MainDialog from '@/components/Common/MainDialog'
import VueWechatTitle from 'vue-wechat-title'

import {
  Autocomplete,
  Button,
  Checkbox,
  Cascader,
  CheckboxGroup,
  DatePicker,
  Dialog,
  Input,
  Loading,
  Message,
  MessageBox,
  Notification,
  RadioGroup,
  Scrollbar,
  Select,
  Option,
  Tag,
  Radio,
  Pagination,
  Backtop
} from 'element-ui'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

Vue.use(Autocomplete)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Cascader)
Vue.use(CheckboxGroup)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(DatePicker)
Vue.use(Loading.directive)
Vue.use(RadioGroup)
Vue.use(Scrollbar)
Vue.use(Select)
Vue.use(Option)
Vue.use(Radio)
Vue.use(Tag)
Vue.use(Pagination)
Vue.use(VueWechatTitle)
Vue.use(Backtop)
Vue.prototype.$loading = Loading.service
Vue.component('Flex', Flex)
Vue.component('BackTop', BackTop)
Vue.component('MainDialog', MainDialog)
Vue.component(CollapseTransition.name, CollapseTransition)
Vue.prototype.$message = Message
Vue.prototype.$messageBox = MessageBox
Vue.prototype.$notify = Notification

Vue.config.productionTip = false
// 注册filter
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

/* eslint-disable no-new */
const vRouter = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  data: {
    eventHub: new Vue() // global event bus
  },
  template: '<App/>'
})

Vue.use({
  vRouter
})
